"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompleteForm = exports.useSendFormUpdate = exports.useVerifyFormToken = exports.useSendForm = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function useSendForm(taskId) {
    const _a = (0, core_ui_1.useApiPost)(`tasks/plugins/send-form/${taskId}`), { data, post } = _a, result = __rest(_a, ["data", "post"]);
    const sendForm = (0, react_1.useCallback)((dto) => post(dto), [post]);
    return Object.assign(Object.assign({}, result), { emails: data, sendForm });
}
exports.useSendForm = useSendForm;
function useVerifyFormToken() {
    const _a = (0, core_ui_1.useApiGet)('tasks/plugins/send-form/verify'), { data, get } = _a, result = __rest(_a, ["data", "get"]);
    const verifyToken = (0, react_1.useCallback)((token) => get({ token }), [get]);
    return Object.assign(Object.assign({}, result), { result: data, verifyToken });
}
exports.useVerifyFormToken = useVerifyFormToken;
function useSendFormUpdate(token, tableName, id) {
    const _a = (0, core_ui_1.useApiPatch)(`tasks/plugins/send-form/data/${tableName}/${id}`), { data, patch } = _a, result = __rest(_a, ["data", "patch"]);
    const update = (0, react_1.useCallback)((data) => patch({ token, data }), [token, patch]);
    return Object.assign(Object.assign({}, result), { entityData: data, update });
}
exports.useSendFormUpdate = useSendFormUpdate;
function useCompleteForm() {
    const _a = (0, core_ui_1.useApiPost)(`tasks/plugins/send-form/complete`), { data, post } = _a, result = __rest(_a, ["data", "post"]);
    const completeForm = (0, react_1.useCallback)((token) => post({ token }), [post]);
    return Object.assign(Object.assign({}, result), { task: data, completeForm });
}
exports.useCompleteForm = useCompleteForm;
//# sourceMappingURL=SendForm.hooks.js.map